import qs from 'query-string';
import { isApiError, SerializableParameter } from './sbapi-client-types';
import EmptyResponseError from '../error/empty-response-error';

export const buildRoute = (
	baseUrl: string,
	path: string,
	parameters: { [ref: string]: SerializableParameter } | undefined,
	franchiseCode: string,
	locale: string
): string => {
	const defaultParameters = { franchiseCode, locale };

	const queryString = qs.stringify(parameters ? { ...defaultParameters, ...parameters } : defaultParameters, {
		encode: true
	});

	return `${baseUrl}${path}?${queryString}`;
};

export const createTimeoutSignal = (timeoutMs: number): { signal: AbortSignal; cleanup: () => void } => {
	if (typeof (AbortSignal as unknown as { timeout?: (ms: number) => AbortSignal }).timeout === 'function') {
		return {
			signal: (AbortSignal as unknown as { timeout: (ms: number) => AbortSignal }).timeout(timeoutMs),
			cleanup: () => {}
		};
	}

	const controller = new AbortController();
	const timeoutId = setTimeout(() => controller.abort(), timeoutMs);

	return {
		signal: controller.signal,
		cleanup: () => clearTimeout(timeoutId)
	};
};

export const parseResponse = async <T>(response: Response, path: string): Promise<T> => {
	if (!response.ok) {
		throw new Error(`Error in ${path}: ${response.status}, ${response.statusText}`);
	}

	const responseBody = await response.text();
	if (!responseBody) {
		throw new EmptyResponseError(`Empty response body for ${path}`);
	}

	const parsedResponse = JSON.parse(responseBody) as T;

	if (isApiError(parsedResponse)) {
		throw new Error(parsedResponse.error);
	}

	return parsedResponse;
};
